var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",style:({zIndex:_vm.zIndex}),on:{"click":_vm.handleClick,"touchmove":_vm.handleTouchmove}})}
var staticRenderFns = []

export { render, staticRenderFns }